<div class="ui-checkbox" [class.ui-checkbox--checked]="checked()" [class.ui-checkbox--disabled]="disabled()">
  <button class="ui-checkbox__button" (click)="buttonClicked($event)" data-cy="checkbox-button">
    <div class="icon-wrapper">
      <ui-icon icon="check-single" [sizeInPixels]="16" color="pure-white" />
    </div>
  </button>
  <div class="ui-checkbox__label"><ng-content /></div>
</div>
